import React from 'react'
import { useHistory } from 'react-router-dom'
import { CellCompProps } from 'src/components/Table/Table'
import { Asset } from 'src/types'

const AssetLinkCell = <T extends Asset> ({ row, col }: CellCompProps<T>) => {
  const val = row[col.name]
  const history = useHistory()
  const handleClick = () => history.push('/assets/' + (row.slug || row.activeID))
  return (
    <div title={val} className={`cell ${col.name}`} onClick={handleClick}>
      {val}
    </div>
  )
}

export default AssetLinkCell
